(function($) {

    "use strict";

    function preloaderLoad() {
        if($('.preloader').length){
            $('.preloader').delay(200).fadeOut(300);
        }
        $(".preloader_disabler").on('click', function() {
            $("#preloader").hide();
        });
    }

    function navbarScrollfixed() {
        $('.navbar-scrolltofixed').scrollToFixed();
        var summaries = $('.summary');
        summaries.each(function(i) {
            var summary = $(summaries[i]);
            var next = summaries[i + 1];
            summary.scrollToFixed({
                marginTop: $('.navbar-scrolltofixed').outerHeight(true) + 10,
                limit: function() {
                    var limit = 0;
                    if (next) {
                        limit = $(next).offset().top - $(this).outerHeight(true) - 10;
                    } else {
                        limit = $('.footer').offset().top - $(this).outerHeight(true) - 10;
                    }
                    return limit;
                },
                zIndex: 999
            });
        });
    }

    $(document).on('ready', function() {
        $("#respMenu").aceResponsiveMenu({
            resizeWidth: '768', // Set the same in Media query
            animationSpeed: 'fast', //slow, medium, fast
            accoridonExpAll: false //Expands all the accordion menu on click
        });
    });

    function mobileNavToggle() {
        if ($('#main-nav-bar .navbar-nav .sub-menu').length) {
            var subMenu = $('#main-nav-bar .navbar-nav .sub-menu');
            subMenu.parent('li').children('a').append(function () {
                return '<button class="sub-nav-toggler"> <span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span> </button>';
            });
            var subNavToggler = $('#main-nav-bar .navbar-nav .sub-nav-toggler');
            subNavToggler.on('click', function () {
                var Self = $(this);
                Self.parent().parent().children('.sub-menu').slideToggle();
                return false;
            });
        };
    }

    $(window).on('scroll', function() {
        if ($('.stricky').length) {
            var headerScrollPos = $('.header-navigation').next().offset().top;
            var stricky = $('.stricky');
            if ($(window).scrollTop() > headerScrollPos) {
                stricky.removeClass('slideIn animated');
                stricky.addClass('stricky-fixed slideInDown animated');
            } else if ($(this).scrollTop() <= headerScrollPos) {
                stricky.removeClass('stricky-fixed slideInDown animated');
                stricky.addClass('slideIn animated');
            }
        };
    });

    $(".mouse_scroll").on('click', function() {
        $('html, body').animate({
            scrollTop: $("#feature-property, #property-city").offset().top
        }, 1000);
    });

        $('.expandable').each(function () {
            let maxHeight = 300;
            let div = $(this);

            if(div.height() > maxHeight) {
                div.attr('data-original-height', div.height()).css('height', maxHeight);
                div.siblings('.show-all').removeClass('d-none').addClass('d-block');

                div.siblings('.show-all').on('click', function(e) {
                    e.preventDefault();

                    div
                        .animate({height: div.attr('data-original-height')},200)
                        .addClass('expanded');

                    $(this).addClass('d-none');
                });
            }
        })


    $(document).on('ready', function() {
        $('.collapse').on('show.bs.collapse', function () {
            $(this).siblings('.card-header').addClass('active');
        });
        $('.collapse').on('hide.bs.collapse', function () {
            $(this).siblings('.card-header').removeClass('active');
        });

    });

    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function(tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })

    // $(document).on('ready', function() {
    //     $('.cart_btn').children('ul.cart').children('li').each(function(indexCount){
    //         $(this).children('ul.dropdown_content').children('li').each(function(index){
    //             var delay = 0.1 + index*0.03;
    //             $(this).css("animation-delay", delay + "s")
    //         });
    //     });
    // });

    document.addEventListener('DOMContentLoaded', () => {
      new Mmenu("#menu", {
          navbar: {
              add: false,
          },
          slidingSubmenus: false,
          offCanvas: {
              position: "right-front"
          }
      },
      {});
    });

    var showSuggestions = function() {
      $( ".advance-search-field form.form-search .box-search" ).each(function() {
        $( "form.form-search .box-search input" ).on('focus', (function() {
          $(this).closest('.boxed').children('.overlay').css({
            opacity: '1',
            display: 'block'
          });
          $(this).parent('.box-search').children('.search-suggestions').css({
            opacity: '1',
            visibility: 'visible',
            top: '55px'
          });
        }));
        $( "form.form-search .box-search input" ).on('blur', (function() {
          $(this).closest('.boxed').children('.overlay').css({
            opacity: '0',
            display: 'block'
          });
          $(this).parent('.box-search').children('.search-suggestions').css({
            opacity: '0',
            visibility: 'hidden',
            top: '100px'
          });
        }));
      });
    };

    $(function() {
      showSuggestions();
    });

    $(document).on('ready', function() {
        $(".slider-range").slider({
            range: true,
            min: 0,
            max: 100000,
            values: [ 20, 70987 ],
            slide: function( event, ui ) {
                $( ".amount"  ).val( ui.values[ 0 ] );
                $( ".amount2"  ).val( ui.values[ 1 ] );
            }
        });
        $(".amount").change(function() {
            $(".slider-range").slider('values',0,$(this).val());
        });
        $(".amount2").change(function() {
            $(".slider-range").slider('values',1,$(this).val());
        });
    });

    $(".popup-img").magnificPopup({
        type:"image",
        gallery: {
            enabled: true,
        }
    });
    $(".popup-img-single").magnificPopup({
        type:"image",
        gallery: {
            enabled: false,
        }
    });
    $('.popup-iframe').magnificPopup({
        type: 'iframe',
        preloader: false,
        fixedContentPos: false
    });
    $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });

    $('.popup-img-gallery').each(function () {

        let gallery = $(this);

        gallery.magnificPopup({
            delegate: '.gallery-popup-img',
            type:"image",
            gallery: {
                enabled: true,
            }
        });

        let button = $(this).find('.all-tag');

        if(button.length) {
            button.on('click', function () {
                gallery.magnificPopup('open');
            })
        }
    })

    var perspectiveHover = function() {
      var $animate_content               = $('.animate_content'),
          $animate_thumb          = $('.animate_thumb'),
          xAngle              = 0,
          yAngle              = 0,
          zValue              = 0,
          xSensitivity        = 15,
          ySensitivity        = 25,
          restAnimSpeed       = 300,
          perspective         = 500;

      $animate_content.on('mousemove', function(element) {
          var $item = $(this),
              // Get cursor coordinates
              XRel = element.pageX - $item.offset().left,
              YRel = element.pageY - $item.offset().top,
              width = $item.width();

          // Build angle val from container width and cursor value
          xAngle = (0.5 - (YRel / width)) * xSensitivity;
          yAngle = -(0.5 - (XRel / width)) * ySensitivity;

          // Container isn't manipulated, only child elements within
          updateElement($item.children($animate_thumb));
      });
      // Move element around
      function updateElement(modifyLayer) {
          modifyLayer.css({
              'transform': 'perspective('+ perspective + 'px) translateZ(' + zValue + 'px) rotateX(' + xAngle + 'deg) rotateY(' + yAngle + 'deg)',
              'transition': 'none'
          });
      }
      // Reset element to default state
      $animate_content.on('mouseleave', function() {
          let modifyLayer = $(this).children($animate_thumb);
          modifyLayer.css({
              'transform': 'perspective(' + perspective + 'px) translateZ(0) rotateX(0) rotateY(0)',
              'transition': 'transform ' + restAnimSpeed + 'ms linear'
          });
      });
    };
    perspectiveHover();

    $(".mouse_scroll").on('click', function() {
      $('html, body').animate({
          scrollTop: $("#explore-property").offset().top
      }, 1200);
    });

    $(function() {
        $('.scroll-balance').each(function () {
            let scrollbalance = new ScrollBalance($(this), {
                minwidth: 0
            });

            scrollbalance.bind();
        })
    });

    $(document).on('ready', function(){
        $(".drop_btn").on('click',function(){
            $(".drop_content").toggle();
        });
        $(".drop_btn2").on('click',function(){
            $(".drop_content2").toggle();
        });
        $(".drop_btn3").on('click',function(){
            $(".drop_content3").toggle();
        });
        $(".drop_btn4").on('click',function(){
            $(".drop_content4").toggle();
        });
    });

    $(document).on('ready', function() {
        navbarScrollfixed();
        mobileNavToggle();
    });

    $(window).on('load', function() {
        preloaderLoad();
    });

    $(window).on('scroll', function() {});

    if ($('.thumbimg-countnumber-carousel').length) {
        var myCarousel = $('.thumbimg-countnumber-carousel');
        var singleItem = '.slider-slide-item';
        var nextBtn = $('.slider-navigation-btn .left-btn');
        var prevBtn = $('.slider-navigation-btn .right-btn');
        var textCountWrap = $('.slider-number-count');
        // dynamic count for carousel
        myCarousel.on('initialize.owl.carousel changed.owl.carousel', function(e) {
            var idx = e.item.index;
            var carouselCount = e.item.count;
            if (!e.namespace) {
                return;
            }
            var carousel = e.relatedTarget;
            var text =  '<span class="current-number">'+ '0' + ( carousel.relative(carousel.current()) + 1 ) +'</span>' +  '<span class="sep">/</span>' + '<span class="counted-number">'+ '0'+carousel.items().length +'</span>';
            textCountWrap.html(text);
        }).owlCarousel({
            loop: true,
            items: 1,
            margin: 0,
            dots: true,
            nav: false,
            animateOut: 'slideOutDown',
            animateIn: 'fadeIn',
            smartSpeed: 1000,
            autoplay: 5000,
            autoplayHoverPause: true
        });
        nextBtn.on('click', function() {
            myCarousel.trigger('next.owl.carousel', [300]);
            return false;
        });
        prevBtn.on('click', function() {
            myCarousel.trigger('prev.owl.carousel', [300]);
            return false;
        });
        // making thumbnail to owl dots
        var thumbCount = myCarousel.find('.owl-dot').length;
        for (var i = 0; i < thumbCount; i++) {
            var newIdx = i + 2;
            var itemThumb = myCarousel.find(singleItem).eq(newIdx).data('thumb');
            myCarousel.find('.owl-dot').eq(i).find('span').css('background-image', 'url(' + itemThumb + ')');
        }
    }

    /*  Team-Slider-Owl-carousel  */
    if($('.instagram_slider').length){
        $('.instagram_slider').owlCarousel({
            loop:true,
            margin:30,
            dots:false,
            nav:false,
            rtl:false,
            autoplayHoverPause:false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="far fa-arrow-left-long"></i>',
                '<i class="far fa-arrow-right-long"></i>'
            ],
            responsive: {
                0: {
                    items: 1,
                    center: false
                },
                320:{
                    items:1,
                    center: false
                },
                375:{
                    items:2,
                    center: false
                },
                520:{
                    items:2,
                    center: false
                },
                600: {
                    items: 2,
                    center: false
                },
                768: {
                    items: 2
                },
                992: {
                    items: 3
                },
                1200: {
                    items: 4
                },
                1366: {
                    items: 5
                },
                1400: {
                    items: 5
                }
            }
        })
    }

    /*  Shop-Item-3-Grid-Slider-Owl-carousel  */
    if($('.slider-1-grid').length){
        $('.slider-1-grid').owlCarousel({
            loop:true,
            margin:30,
            center:false,
            dots:true,
            nav:true,
            rtl:false,
            autoplayHoverPause:false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="far fa-arrow-left-long"></i>',
                '<i class="far fa-arrow-right-long"></i>'
            ],
            responsive: {
                0: {
                    items: 1,
                    center: false
                },
                480:{
                    items:1,
                    center: false
                },
                768: {
                    items: 1
                },
                992: {
                    items: 1
                },
                1200: {
                    items: 1
                }
            }
        })
    }

    /*  Shop-Item-2-Grid-Slider-Owl-carousel  */
    if($('.slider-2-grid').length){
        $('.slider-2-grid').owlCarousel({
            loop:true,
            margin:30,
            center:false,
            dots:true,
            nav:true,
            rtl:false,
            autoplayHoverPause:false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="far fa-arrow-left-long"></i>',
                '<i class="far fa-arrow-right-long"></i>'
            ],
            responsive: {
                0: {
                    items: 1,
                    center: false
                },
                480:{
                    items:1,
                    center: false
                },
                600: {
                    items: 1,
                    center: false
                },
                768: {
                    items: 2
                },
                992: {
                    items: 2
                },
                1200: {
                    items: 2
                }
            }
        })
    }

    /*  Shop-Item-3-Grid-Slider-Owl-carousel  */
    if($('.slider-3-grid').length){
        $('.slider-3-grid').owlCarousel({
            loop:true,
            margin:30,
            center:false,
            dots:true,
            nav:true,
            rtl:false,
            autoplayHoverPause:false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="far fa-arrow-left-long"></i>',
                '<i class="far fa-arrow-right-long"></i>'
            ],
            responsive: {
                0: {
                    items: 1,
                    center: false
                },
                480:{
                    items:1,
                    center: false
                },
                600: {
                    items: 1,
                    center: false
                },
                768: {
                    items: 2
                },
                992: {
                    items: 2
                },
                1200: {
                    items: 3
                }
            }
        })
    }

    /*  Shop-Item-4-Grid-Slider-Owl-carousel  */
    if($('.slider-4-grid').length){
        $('.slider-4-grid').owlCarousel({
            loop:true,
            margin:30,
            center:false,
            dots:true,
            nav:true,
            rtl:false,
            autoplayHoverPause:false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="far fa-arrow-left-long"></i>',
                '<i class="far fa-arrow-right-long"></i>'
            ],
            responsive: {
                0: {
                    items: 1,
                    center: false
                },
                375:{
                    items:2,
                    center: false
                },
                600: {
                    items: 2,
                    center: false
                },
                768: {
                    items: 2
                },
                992: {
                    items: 2
                },
                1024: {
                    items: 3
                },
                1200: {
                    items: 4
                }
            }
        })
    }

    /*  Shop-Item-4-Grid-Slider-Owl-carousel  */
    if($('.slider-4-grid2').length){
        $('.slider-4-grid2').owlCarousel({
            loop:true,
            margin:30,
            center:false,
            dots:true,
            nav:true,
            rtl:false,
            autoplayHoverPause:false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="far fa-chevron-left"></i>',
                '<i class="far fa-chevron-right"></i>'
            ],
            responsive: {
                0: {
                    items: 1,
                    center: false
                },
                375:{
                    items:2,
                    center: false
                },
                600: {
                    items: 2,
                    center: false
                },
                768: {
                    items: 2
                },
                992: {
                    items: 2
                },
                1024: {
                    items: 3
                },
                1200: {
                    items: 4
                }
            }
        })
    }

    /*  Shop-Item-4-Grid-Slider-Owl-carousel  */
    if($('.slider-4-grid3').length){
        $('.slider-4-grid3').owlCarousel({
            loop:true,
            margin:30,
            center:false,
            dots:true,
            nav:true,
            rtl:false,
            autoplayHoverPause:false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="far fa-arrow-left-long"></i>',
                '<i class="far fa-arrow-right-long"></i>'
            ],
            responsive: {
                0: {
                    items: 1,
                    center: false
                },
                580: {
                    items: 2,
                    center: false
                },
                992: {
                    items: 2
                },
                1024: {
                    items: 3
                },
                1200: {
                    items: 4
                }
            }
        })
    }

    /*  Shop-Item-5-Grid-Slider-Owl-carousel  */
    if($('.slider-5-grid').length){
        $('.slider-5-grid').owlCarousel({
            loop:true,
            margin:30,
            dots:true,
            nav:true,
            rtl:false,
            center:false,
            autoplayHoverPause:false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="far fa-arrow-left-long"></i>',
                '<i class="far fa-arrow-right-long"></i>'
            ],
            responsive: {
                0: {
                    items: 1,
                    center: false
                },
                375:{
                    items:2,
                    center: false
                },
                520:{
                    items:2,
                    center: false
                },
                767: {
                    items: 2,
                    center: false
                },
                768: {
                    items: 2
                },
                992: {
                    items: 3
                },
                1200: {
                    items: 3
                },
                1366: {
                    items: 4
                },
                1400: {
                    items: 5
                }
            }
        })
    }

    /*  Shop-Item-6-Grid-Slider-Owl-carousel  */
    if($('.slider-6-grid').length){
        $('.slider-6-grid').owlCarousel({
            loop:true,
            margin:30,
            center:false,
            dots:true,
            nav:true,
            rtl:false,
            autoplayHoverPause:false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="far fa-arrow-left-long"></i>',
                '<i class="far fa-arrow-right-long"></i>'
            ],
            responsive: {
                0: {
                    items: 2,
                    center: false
                },
                480:{
                    items:2,
                    center: false
                },
                630: {
                    items: 2,
                    center: false
                },
                768: {
                    items: 3
                },
                992: {
                    items: 3
                },
                1024: {
                    items: 3
                },
                1200: {
                    items: 4
                },
                1400: {
                    items: 6
                }
            }
        })
    }

    /*  Shop-Item-7-Grid-Slider-Owl-carousel  */
    if($('.slider-7-grid').length){
        $('.slider-7-grid').owlCarousel({
            loop:true,
            margin:5,
            center:false,
            dots:true,
            nav:true,
            rtl:false,
            autoplayHoverPause:false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="far fa-arrow-left-long"></i>',
                '<i class="far fa-arrow-right-long"></i>'
            ],
            responsive: {
                0: {
                    items: 2,
                    center: false
                },
                480:{
                    items:2,
                    center: false
                },
                520: {
                    items: 2,
                    center: false
                },
                767: {
                    items: 2,
                    center: false
                },
                768: {
                    items: 3
                },
                992: {
                    items: 4
                },
                1024: {
                    items: 4
                },
                1200: {
                    items: 5
                },
                1400: {
                    items: 5
                },
                1500: {
                    items: 7
                }
            }
        })
    }

    /*  Shop-Item-7-Grid-Slider-Owl-carousel  */
    if($('.slider-8-grid').length){
        $('.slider-8-grid').owlCarousel({
            loop:true,
            margin:0,
            center:false,
            dots:true,
            nav:true,
            rtl:false,
            autoplayHoverPause:false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="far fa-arrow-left-long"></i>',
                '<i class="far fa-arrow-right-long"></i>'
            ],
            responsive: {
                0: {
                    items: 2,
                    center: false
                },
                480:{
                    items:2,
                    center: false
                },
                520: {
                    items: 2,
                    center: false
                },
                767: {
                    items: 2,
                    center: false
                },
                768: {
                    items: 3
                },
                992: {
                    items: 4
                },
                1024: {
                    items: 4
                },
                1200: {
                    items: 5
                },
                1400: {
                    items: 7
                },
                1500: {
                    items: 8
                }
            }
        })
    }

    /*  Shop-Item-10-Grid-Slider-Owl-carousel  */
    if($('.slider-10-grid').length){
        $('.slider-10-grid').owlCarousel({
            loop:true,
            margin:0,
            center:false,
            dots:true,
            nav:true,
            rtl:false,
            autoplayHoverPause:false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="far fa-arrow-left-long"></i>',
                '<i class="far fa-arrow-right-long"></i>'
            ],
            responsive: {
                0: {
                    items: 2,
                    center: false
                },
                480:{
                    items:2,
                    center: false
                },
                520: {
                    items: 2,
                    center: false
                },
                767: {
                    items: 2,
                    center: false
                },
                768: {
                    items: 3
                },
                992: {
                    items: 4
                },
                1024: {
                    items: 4
                },
                1200: {
                    items: 5
                },
                1400: {
                    items: 7
                },
                1500: {
                    items: 10
                }
            }
        })
    }

    /*  Team-Slider-Owl-carousel  */
    if($('.bestseller_sidebar_slider').length){
        $('.bestseller_sidebar_slider').owlCarousel({
            loop:true,
            margin:30,
            dots:true,
            nav:true,
            rtl:false,
            center:false,
            autoplayHoverPause:false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="far fa-arrow-left-long"></i>',
                '<i class="far fa-arrow-right-long"></i>'
            ],
            responsive: {
                0: {
                    items: 1,
                    center: false
                },
                480:{
                    items:1,
                    center: false
                },
                520:{
                    items:1,
                    center: false
                },
                768: {
                    items: 1
                },
                992: {
                    items: 1
                },
                1200: {
                    items: 1
                }
            }
        })
    }

    /*  Expert-Freelancer-Owl-carousel  */
    if ($('.banner-style-one').length) {
        $('.banner-style-one').owlCarousel({
            loop: true,
            items: 1,
            margin: 0,
            dots: true,
            nav: true,
            animateOut: 'slideOutDown',
            animateIn: 'fadeIn',
            active: true,
            smartSpeed: 1000,
            autoplay: false
        });
        $('.banner-carousel-btn .left-btn').on('click', function() {
            $('.banner-style-one').trigger('next.owl.carousel');
            return false;
        });
        $('.banner-carousel-btn .right-btn').on('click', function() {
            $('.banner-style-one').trigger('prev.owl.carousel');
            return false;
        });
    }


})(window.jQuery);
